<template>
    <div v-loading="mixinLoading">
        <Query ref="query" :page="pageName" @query-click="handleQueryClick" :list="allFilterList"/>
        <!-- 自定义列 -->
        <CustomizeModal
        ref="refcustomizeModal"
        :customList="assignObj"
        :selectList="selectList"
        :customBtnLoading="customBtnLoading"
        @getCustomList="getCustomList"/>
        <div class="com-table-view-apple">
            <div class="operation-box" id="operation-box">
                <div class="operation-left">
                     <el-menu
                         v-if="isHasBatchAuth"
                        class="apple-cascader"
                        mode="horizontal"
                        @select="(val)=>handleCommand(val, '')">
                        <el-submenu index="1" :popper-append-to-body="false">
                            <template slot="title"><span>Batch Edit</span></template>
                            <el-menu-item index="1" v-if="!isHasAuth('add_as_keyword')" :disabled="isEmptySelection"><span class="text-color-normal">Add as keyword</span></el-menu-item>
                            <el-menu-item index="2" v-if="!isHasAuth('add_as_negative_keyword')" :disabled="isEmptySelection"><span class="text-color-normal">Add as negative keyword</span></el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <span v-if="multipleSelection.length>0" style="padding-left: 8px;">{{multipleSelection.length}} Items Selected</span>
                </div>
                <div class="operation-right">
                    <el-button
                        icon="el-icon-s-operation"
                        size="mini"
                        @click="handleShowDefineRow">Custom Columns</el-button>
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        v-if="!isHasAuth('export')"
                        :loading="exportLoading"
                        @click="handleExport">Export</el-button>
                </div>
            </div>

            <div style="min-height: 200px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    ref="multipleTable"
                    :row-key="getRowKey"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @selection-change="handleSelectionChange"
                    @sort-change="handlesortchange"
                    v-loading="!mixinLoading && loading"
                    header-row-class-name="jt_sticky"
                >
                    <!--复选框）-->
                     <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                        fixed="left"
                        :selectable="(row,index)=>(row.search_term_text!='低展示词'&&row.search_term_text!='(Low volume terms)')&&index!==0"
                        >
                    </el-table-column>
                    <!-- 默认 -->
                    <el-table-column
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align"
                        :min-width="column.width"
                        :fixed="column.fixed !='' ? column.fixed : false"
                        :sortable="getsortable(column['field_type'], column.name)"
                        v-for="(column, index) in columns"
                        :key="index"
                        :render-header="(h, values)=>renderHeader(h, values, column)"
                        >
                        <template slot-scope="scope">
                            <div v-if="scope.$index===0" class="">
                                <span v-if="column.name==firstColumnName">Total</span>
                                <div v-else-if="scope.row[column.name]">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>
                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>
                                <span v-else>-</span>
                            </div>
                            <template v-else>
                                <div class="table_operate" v-if="column.field_type=='1' && column.name=='operate'">
                                    <!-- <span  @click="handledrawer(scope.$index)" style="color: #ff0000;">Delete</span> -->
                                    <el-button type="text" @click="handleDel(scope.$index, 'del')"><span style="color: #ff0000;">Delete</span></el-button>
                                </div>

                                <div v-if="column.field_type=='1' && column.name=='plan_name_start_date'">
                                    <p>{{scope.row['start_time']}}</p>
                                    <p>{{scope.row['end_time']}}</p>
                                </div>

                                <div v-else-if="column.field_type=='2'">
                                    <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                        <div class="column_name text-nowrap">
                                            {{ getcurrency(scope.row, column.name)['name'] }}
                                        </div>
                                        <div class="column_currency">
                                            {{ getcurrency(scope.row, column.name)['currency'] }}
                                        </div>

                                    </div>
                                    <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                                </div>

                                <div class="lineheightmax"  v-else>{{scope.row[column.name]}}</div>
                            </template>

                        </template>
                    </el-table-column>

                </el-table>
            </div>

            <div class="component_pagination">
                <el-pagination
                    v-if="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pn"
                    :page-sizes="[30, 50, 100]"
                    :page-size="rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>

            </div>


            <el-dialog
                :title="null"
                :visible.sync="dialogVisible"
                :close-on-click-modal=false
                :close-on-press-escape=false
                :show-close=false
                :destroy-on-close=true
                width="450px"
                custom-class="apple-dialog-err">
                <div>
                    <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                    <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
                </div>
            </el-dialog>

            <BatchBudgetModal ref="batchBudgetModal" :list="multipleSelection" @update="getListBody(props_params)" />

            <NegativeKeywordModal ref="negativeKeywordModal" :action-rows="actionRows" :form-data="actionRowData" @update="clearMultipleSelection" action-type="searchTermAddAsNegativeKeyword"/>
            <KeywordModal ref="keywordModal" :action-rows="actionRows" :form-data="actionRowData" @update="clearMultipleSelection" action-type="searchTermAddAsKeyword"/>
            <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
                <div class="tip-apple-content" slot="content">{{tipContent}}</div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Query from "../../components/query.vue";
    import CustomizeModal from '../../modal/customizeModal';
    import API from '@/api/marketManage/apple/index-en';
    import BatchBudgetModal from '../../campaign/modal/batchBudgetModal';
    import { cloneDeep, debounce } from 'lodash'
    import utils from '@/libs/utils.js';
    import NegativeKeywordModal from '../modal/negativeKeywordModal';
    import KeywordModal from '../modal/keywordModal';
    const other_Table_columns_no_sort = ['search_term_start_date', 'creation_time']
    import { EarlyWarnMixin } from '@/views/marketingManagement/mixins'
   export default {
        name: "SearchTermPage",
         mixins: [ EarlyWarnMixin({language: "EN", page: 'search_term' }) ],
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageActionNames:Array,
        },
        components: {
            Query,
            CustomizeModal,
            BatchBudgetModal,
            NegativeKeywordModal,
            KeywordModal,
        },
        data() {
            return {
                pageName:'apple_promotion_manage_search_term',
                value:true,
                props_params: {}, //query 组件吐出参数 对象形式  (一般用在勾选操作与导出)
                btnloading: false,  //每日预算按钮loading
                active: -1, // 每日预算点击
                drawer: false, //抽屉
                pagination: true,
                pn: 1,
                rn: 30,
                totalCnt:0,
                selectList: [],
                multipleSelection: [],
                columns: [],
                tableData:[],
                customBtnLoading: false, //自定义列按钮loading
                activeIndex: -1, //选中的详情条数
                cacha_money: '',  //缓存每日预算
                cacha_name: '', //缓存广告系列名称
                infoValue: false, // 详情开关
                infoactive: false, // 详情广告名称 显示输入与否
                infoysactive: false, //详情每日预算  显示与否
                infoName: '', // 广告系列名称
                show: false, //处理表格头显示后 显示表格
                loading: false, //处理表格loading
                options: [
                    {
                        value: '1',
                        label: 'Switch - Run',
                        children: [
                            {
                                value: 'all',
                                label: 'Select All',
                            }
                        ]
                    },
                    {
                        value: '2',
                        label: 'Switch - Pause',
                    },
                    {
                        value: '3',
                        label: 'Copy',
                    },
                    {
                        value: '4',
                        label: 'Daily Budget',
                    },
                    {
                        value: '5',
                        label: 'Delete',
                    }
                ],
                dialogVisible: false,   //各种错误提示
                dialogBoo: true,   // 是否失败
                dialogType: 1,   //1单个处理 2多个处理
                dialogTypeTitle: 'Request successful, processing…', //显示提示头
                dialogTypeBody: '1000027869，Processing, please wait', //显示提示头
                mulerrIds: '',
                mulErr:'',
                mulexc: '',
                cachaHeader: 1,
                actionType:'',      // 记录关键词弹窗的 添加/复制
                showPopper: false, //浮层提醒
                tipContent: '',    //浮层提醒内容
                exportLoading:false,
            }
        },
        computed:{
            ...mapGetters(['apple_reload','apple_list_page_query']),
            allFilterList(){
                let dimensions = cloneDeep(this.pageDimension)
                /* 需要过滤掉[操作]列 */
                return dimensions.filter(item=>item.config&&item.name!='operate').map(item=>{
                    item.config = JSON.parse(item.config);
                    return item;
                })
            },
            assignObj() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    item['meconfig'] = item['config'] && JSON.parse(item.config);
                    return item;
                })
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                })
                let baselist = {
                    id : "b_1000",
                    name: 'base',
                    display_name: 'Basic Information',
                    children: res_dime
                }
                return [baselist,...res_pageFields]
            },
            getappledialogerr() {
                if(this.mulErr != '' && this.mulexc != '') {
                    return 1
                }else if(this.mulErr != '' || this.mulexc != ''){
                    return 2
                }else{
                    return 3
                }
            },
            isEmptySelection(){
                return this.multipleSelection.length<=0;
            },
            actionRows(){
                return this.multipleSelection.map(item=>{
                    return {
                        key_word_text:item.search_term_text,
                        match_type:item.match_type=='精准匹配'||item.match_type=='广泛匹配'?item.match_type:'精准匹配',
                        bid_amount:item.bid_amount&&item.bid_amount!='-'?item.bid_amount:'',
                        org_id:item.org_id,
                        org_name:item.org_name,
                        campaign_id:item.campaign_id,
                        campaign_name:item.campaign_name,
                        adgroup_id:item.adgroup_id,
                        adgroup_name:item.adgroup_name,
                        bid_amount_currency:item.bid_amount_currency,
                    }
                })
            },
            actionRowData(){
                let orgIds = this.actionRows.map(item=>item.org_id).filter(item=>!!item);
                let campaignIds = this.actionRows.map(item=>item.campaign_id).filter(item=>!!item);
                let adGroupIds = this.actionRows.map(item=>item.adgroup_id).filter(item=>!!item);
                let row = this.actionRows[0]||{};
                let data = {};

                /* 判断是否需要设置默认值 */
                if(orgIds.every(item=>item===row.org_id)){
                    data.org_id = row.org_id;
                    data.org_name = row.org_name;
                }
                if(campaignIds.every(item=>item===row.campaign_id)){
                    data.campaign_id = row.campaign_id;
                    data.campaign_name = row.campaign_name;
                }
                if(adGroupIds.every(item=>item===row.adgroup_id)){
                    data.adgroup_id = row.adgroup_id;
                    data.adgroup_name = row.adgroup_name;
                }
                return data;
            },
            firstColumnName(){
                let column = this.columns[0]||{};
                return column.name||'-';
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
            isHasBatchAuth(){
                let funcNames = this.pageFuncNames||[];
                return funcNames.includes('add_as_keyword')||funcNames.includes('add_as_negative_keyword');
            },
        },
        watch: {
            apple_reload: function(val) {
                this.getListBody(this.props_params)
            }
        },
        mounted() {
            this.getEventTip()
            this.getListHead((res)=>{
                const fields = res && res.map(item=>item['name'])
                this.props_params['fields'] = []
                this.props_params['fields'] = fields
            })
        },
        beforeDestroy() {
        },
        methods:{
            getcurrency(rows, name) {
                let name_currency = `${name}_currency`
                if(rows[name_currency]) {
                    return {
                        has: true,
                        name: rows[name],
                        currency: rows[name_currency],
                    }
                }else{
                    return {
                        has: false,
                        name: rows[name]
                    }
                }
            },
            // query 查询  isClear为true：表示点击的是【清空筛选】
            async handleQueryClick(params,isClear) {
                console.log('params', params)
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }
                let range_time = Array.isArray(this.rangeTime) && this.rangeTime.length != 0 ? `${this.rangeTime[0]}/${this.rangeTime[1]}` : ''
                // this.props_params = {...params, range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn}
                this.pn = 1
                this.props_params = Object.assign(this.props_params,params,{range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn})
                // if(this.cachaHeader == 1) {
                //     this.getListHead((res)=>{
                //         const fields = res && res.map(item=>item['name'])
                //         this.props_params['fields'] = []
                //         this.props_params['fields'] = fields
                //         this.getListBody(this.props_params,isClear)
                //     })
                // }else{
                //     this.getListBody(this.props_params,isClear)
                // }
                if((this.props_params.fields||[]).length<=0){
                    await this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields
                    })
                }
                this.getListBody(this.props_params,isClear)
            },
            getRowKey(row) {
                return `${row['adgroup_id']}_${row['search_term_id']}_${row['keyword_id']}_${row['date']}`
            },
            getShowInfoItem(arr, name) {
                if(Array.isArray(arr) && arr.length != 0) {
                    let isshow = arr.some(item=>item['name'] == name)
                    return true
                }else{
                    return false
                }
            },
            // 判断是否显示tip事件
            getEventTip() {
                const _this = this;
                const cellTip = this.$refs.cellTip;
                const delay = 200;

                // 超长提示事件
                $(this.$el).on('mouseenter.tdcell', '.lineheightmax', debounce(function() {

                    const $cell = $(this);
                    if ($cell[0].offsetHeight === $cell[0].scrollHeight) {
                        return;
                    }

                    cellTip.referenceElm = $cell[0];
                    _this.showPopper = true;
                    _this.tipContent = $cell.text();
                }, delay))
                .on('mouseleave.tdcell', '.lineheightmax', function() {
                    if (!_this.showPopper) {
                        return;
                    }

                    _this.showPopper = false;
                    setTimeout(() => {
                        _this.showPopper = false;
                    }, delay);
                });
            },
            getshowTip(name) {
                // campaign_name 广告系列 countries_or_regions 国家跟地区 campaign_display_status 状态 company_name  客户 org_name广告系列组 app_info 产品 bloc_name集团
                const showTip = ['key_word_text', 'search_term_text', 'adgroup_name','org_name','countries_or_regions', 'campaign_display_status', 'company_name', 'app_info', 'bloc_name']
                if(showTip.includes(name)) {
                    return true
                }else{
                    return false
                }
            },
            // 获取权限
            isHasAuth(name){
                let isauth = this.pageFunc.some(item => item['name'] == name)
                return !isauth
            },
            // 获取列表头
            async getListHead(callback) {
                this.$refs.query.setSubmitLoading(true);
                this.loading = true
                await API.getCustomField({field_type: 'apple_promotion_manage_search_term'}).then(res => {
                    let resData = res.data || []
                    this.selectList = resData
                    const width140 = ['keyword_id', 'campaign_id', 'org_id', 'account_name_start_date', 'adgroup_id', 'keyword_display_status', 'creation_time']
                    const width110 = ['account_yy_type', 'yy_name', 'keyword_status', 'supply_source', 'match_type', 'search_term_source', 'level_type']
                    this.columns = [{
                        name:'date',
                        display_name:'Date',
                        width:'100',
                        fixed:'left',
                    }].concat(resData.map(item=>{
                        item["display_name"] = item.label
                        item['align'] = 'left'
                        // 宽度特殊处理
                        if(item['field_type'] == 2) {
                            item['align'] = 'right'
                            let nums = (item['display_name']||'').length
                            /* 曝光均价：单独设置宽度250 */
                            // item['width'] = item.name=='imp_price'?250:((nums * 12)) + 60
                            if(item.name=='imp_price' || item.name == 'local_spend') {
                                item['width'] = 250
                            }else {
                                item['width'] = ((nums * 12)) + 60
                            }
                        }else{
                            if(width140.includes(item.name)) {
                                item['width'] = 120
                            }else if(width110.includes(item.name)){
                                item['width'] = 90
                            }else{
                                item['width'] = 190
                            }
                        }
                        if(item.name == 'keyword_status') {
                            item['align'] = 'center'
                        }
                        return item
                    }))
                    // this.show = true
                    // this.cachaHeader = 2
                    callback && callback(resData)
                }, err=>{
                    this.loading = true
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)
                })
            },
            setListQueryData(){
                let queryData = {
                    org_id:this.props_params.org_id||[],
                    org_name:this.props_params.org_name||[],
                    campaign_id:this.props_params.campaign_id||[],
                    campaign_name:this.props_params.campaign_name||[],
                    adgroup_id:this.props_params.adgroup_id||[],
                    adgroup_name:this.props_params.adgroup_name||[],
                };

                this.$store.commit('apple/SET_LIST_PAGE_QUERY',queryData);
            },
            //  获取列表体
            getListBody(params,isClear) {
                console.log('params',params);
                let fields = params.fields||[];
                if(!fields.includes('date')){
                    params.fields= fields.concat('date');
                }

                    this.loading = true
                    this.$refs.query.setSubmitLoading(true);
                    if(isClear){
                        this.$refs.query.setClearLoading(true);
                    }
                    this.setListQueryData();
                    API.getSearchTermList(params).then(res => {
                        this.loading = false
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                        let resData = res.data
                        this.tableData = [resData.total||{}].concat(resData.list||[]);
                        // this.pn = resData.pageNum
                        this.totalCnt = resData.totalCnt
                    }, err=>{
                        if(err.code =='403'){
                            this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                this.$refs.query.setSubmitLoading(false);
                                });
                            return
                        }
                        this.loading = false
                        this.$message.error(err.info)
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                    })
            },
            // 获取状态颜色
            getStatusColor(val) {
                if(val == 'RUNNING') {
                    return 'text-color-success'
                }else if(val == 'ON_HOLD') {
                    return 'text-color-failed'
                }else{
                    return ''
                }
            },
            // 千分位处理
            formatNumberWithCommas(number) {
                // Check if the input is a valid number
                if (isNaN(number)) {
                    return "错误";
                }
                let formattedNumber = number.toLocaleString();

                if (formattedNumber.indexOf('.') !== -1) {
                    formattedNumber = parseFloat(number).toFixed(2);
                }
                return formattedNumber;
            },
            // 自定义列
            handleShowDefineRow () {
                this.$refs.refcustomizeModal.showModal();
            },
            // 获取自定义列
            getCustomList(values) {
                console.log('values', values)
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: 'apple_promotion_manage_search_term',
                    fields: values
                }).then(res => {
                    console.log('res', res)
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields

                        if(!fields.includes(this.props_params['order_by'])) {
                            this.props_params['order_by'] = ''
                            this.props_params['order_type'] = ''
                        }
                        this.getListBody(this.props_params)
                    })
                }, (err) => {
                    this.customBtnLoading = false
                    console.log('error', err);
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)

                })
            },
            // 多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleCascader(value) {
                console.log('value', value)
            },
            showBatchBudgetModal(){
                this.$refs.batchBudgetModal.showModal();
            },
            // 只可以输入数字
            handleInput(value, rows) {
                rows.daily_budget = `${value}`.replace(/[^1-9\d.]/g, '').replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
            },
            // 导出
            handleExport() {
                this.exportLoading = true;
                API.exportSearchTermList(this.props_params,{
                    timeout: 120 * 1000,
                }).then(res => {
                    this.exportLoading = false;
                    console.log('res', res)
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    this.$message.error(err.info||'Request Error');
                })
            },
            // 排序
            handlesortchange({column, prop, order}) {
                //ascending 升   descending 降
                console.log(column, prop, order)
                let order_type = order == 'ascending' ? 'asc' : 'desc'
                this.props_params['order_by'] = prop
                this.props_params['order_type'] = order_type
                this.getListBody(this.props_params)
            },
            // 排序显示
            getsortable(values, show) {
                if(values && values == 1 && other_Table_columns_no_sort.includes(show)) {
                    return 'custom'
                }
                return (values && values == 2) ? 'custom' : false
            },
            renderHeader(h, values, column) {
                let colName = column.name;
                let actionCol = this._findFieldByName(this.pageFields,colName)||{};
                let content_text = column['config'] && JSON.parse(column['config'])['title']
                let content_text1 = actionCol['config'] && JSON.parse(actionCol['config'])['title']
                let content_html = null
                if(column['field_type'] == 2) {
                    content_html = h(
                                    'el-tooltip',
                                        {
                                            props: {
                                            effect: 'dark',
                                            content: content_text1||content_text,
                                            placement: 'top',
                                            },
                                        },
                                        [
                                            h('i', {
                                            class: 'el-icon-question',
                                            style: 'margin-left:2px;'
                                            }),
                                        ]
                                    )
                }
                return h('div', {
                            style: 'display: inline-block;'
                        },
                [
                    h('div', {class: 'render-header-div'}, [
                        h('span', {
                                class: 'render-header-span',
                                style: this.getEarlyWarnThem(column)
                            }, values.column.label),
                        content_html,
                        this.renderEarlyWarnIcon(h, column)
                    ])

                ])
            },
            // 分页 切换条数
            handleSizeChange(val) {
                this.props_params.rn = val
                this.props_params.pn = 1
                this.rn = val
                this.pn = 1
                this.getListBody(this.props_params)
            },
            // 分页 选择页数
            handleCurrentChange(val) {
                this.props_params.pn = val
                this.pn = val
                this.getListBody(this.props_params)
            },
            // 复制
            handlecopy() {
                let copyTxt = this.mulerrIds.join('\r\n');
                console.log('复制', copyTxt)
                utils.setClipboardText(copyTxt);
                this.$message({
                    message: 'Copied successfully',
                    type: 'success'
                });
                this.dialogVisible = false
            },
            handleCommand(el, index){
                if(el == 1) {
                    // 添加为关键词
                    if(this.multipleSelection.length>0){
                        API.checkSearchTermAddAsKeyword().then(res=>{
                            this.actionType = 'copy';
                            this.$refs.keywordModal.showModal();
                        },err=>{
                            if (err.code == '403') {
                                this.$confirm(err.info||'Request Error', 'Prompt', {
                                    confirmButtonText: 'Refresh',
                                    cancelButtonText: 'Close',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }
                            this.$message.error(err.info||'Request failed');
                        });
                    }
                }else if(el == 2){
                    // 添加为否定关键词
                    if(this.multipleSelection.length>0){
                        API.checkSearchTermAddAsNegativeKeyword().then(res=>{
                            this.actionType = 'copy';
                            this.$refs.negativeKeywordModal.showModal();
                        },err=>{
                            if (err.code == '403') {
                                this.$confirm(err.info||'Request Error', 'Prompt', {
                                    confirmButtonText: 'Refresh',
                                    cancelButtonText: 'Close',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }
                            this.$message.error(err.info||'Request failed');
                        });
                    }
                }
            },
            searchList(){
                let routeParams = this.$route.params||{};
                let $query = this.$refs.query;
                console.log('searchList',routeParams,this.zone,this.rangeTime,$query.getQueryData());
            },
            getSearchList(){
                this.props_params.range_time = this.rangeTime.join('/');
                this.props_params.time_zone = this.zone;
                this.getListBody(this.props_params);
            },
            clearMultipleSelection(){
                this.multipleSelection = [];
                this.$refs.multipleTable.clearSelection();
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/apple_sd.scss";
    #operation-box ::v-deep{
        .apple-cascader.el-menu--horizontal{
            border-bottom: none;
            .el-submenu__title,.el-menu-item{
                font-size: 12px;
            }
            &>.el-submenu .el-submenu__title{
                font-size: 12px;
                padding: 0 15px!important;
                color: #409eff;
                background: #ecf5ff;
                border: solid 1px #b3d8ff;
                height: 28px;
                line-height: 26px;
                border-radius: 3px;
                border-bottom-color: #b3d8ff!important;
                .el-submenu__icon-arrow{
                    color: #409eff;
                    display: inline-block !important;
                }
                &:hover{
                    background: #409eff;
                    border-color: #409eff;
                    color: #fff;
                    .el-submenu__icon-arrow{
                        color: #fff;
                    }
                }
            }

            .el-menu-item:hover{
                background-color:#ecf5ff;
            }
            .err-menu-item:hover{
                background-color:#fef0f0;
            }
        }
    }


.custom_input{
    .el-input__inner{
        padding: 0 8px;
    }
    .el-input-group__append{
        padding: 0 8px;
    }
}
</style>
<style lang="scss" scoped>
    .com-table-view-apple{
        background: #fff;
        /*padding: 10px 10px 10px;*/
        padding: 10px 0 10px;
        border-radius: 3px;
        border: 1px solid #e8eaec;
        margin-top: 10px;
        /*box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);*/
        .operation-box{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-bottom: 10px;
            padding: 0 15px;
            .operation-left{
                display: flex;
                justify-content:flex-start;
                align-items: center;
            }
        }
        .component_pagination{
            padding-top: 20px;
            padding-right: 20px;
            text-align: right;
        }
    }
    .custom_input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 3px;
        padding: 3px;
        .el-input-group__append{
            padding: 0 8px;
        }
        &.active{
            box-shadow: 0 1px 8px #bbb6b6;
        }
        .custom_input_el{
            margin-right: 4px;
            flex: auto;
        }
        .custom_input_btn{
            width: 48px;
            flex: 0 0 48px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .custom_input_success{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 2px solid #67C23A;
            border-radius: 10px;
            background-color: #67C23A;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #9ed881;
                background-color: #9ed881;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
        .custom_input_close{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            border: 2px solid #F56C6C;
            background-color: #F56C6C;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #fe9999;
                background-color: #fe9999;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
    }
    .table_operate{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span{
            cursor: pointer;
        }
    }
    .custom_drawer{
        padding: 0 8px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e8eaec;
            padding: 8px 4px;
        }
        .drawer_list{
            padding: 8px 0;
            h4{
                font-size: 14px;
                margin-bottom: 8px;
            }
            .drawer_item{
                display:flex;
                align-items: center;
                padding: 4px 0;
                &>div{
                    &:first-child {
                        width: 100px;
                        flex: 0 0 100px;
                        padding-left: 16px;
                        color: #272727;
                    }
                    &:last-child {
                        flex: auto
                    }
                }
            }
        }
        .custom_input{
            align-items: flex-end;
            &.center{
                align-items: center;
            }
        }
    }
    .nodata{
        min-height: 300px;
    }
</style>



